import { createFileRoute } from "@tanstack/react-router";
import AppLayout from "@/components/app/AppLayout";
import { COR_DA_BARRA } from "@/lib/app/barra-de-status";
import { pageHead } from "@/lib/seo";

// App das pacientes (PWA instalável). Só no navegador: a sessão é do aparelho e nada aqui vira HTML estático.
export const Route = createFileRoute("/app")({
  ssr: false,
  head: () => {
    const base = pageHead({ title: "Braussie - Nutri", path: "/app", noindex: true });
    return {
      ...base,
      meta: [
        ...base.meta,
        // viewport-fit=cover: no iPhone a barra de baixo respeita a área do gesto (env(safe-area-inset-bottom)).
        { name: "viewport", content: "width=device-width, initial-scale=1, viewport-fit=cover" },
        // A barra de status abre clara, como a abertura; o app troca para a verde nas telas com o degradê no topo.
        { name: "theme-color", content: COR_DA_BARRA.clara },
        { name: "apple-mobile-web-app-capable", content: "yes" },
        { name: "mobile-web-app-capable", content: "yes" },
        { name: "apple-mobile-web-app-title", content: "Braussie - Nutri" },
        { name: "apple-mobile-web-app-status-bar-style", content: "default" },
        { name: "format-detection", content: "telephone=no" },
      ],
      links: [
        { rel: "manifest", href: "/app/manifest.webmanifest" },
        { rel: "apple-touch-icon", sizes: "180x180", href: "/app/icons/apple-touch-icon.png" },
      ],
    };
  },
  component: AppLayout,
});
